import { TS_OfferBanner } from "../TravelSeller/Models/TS_OfferBanner";
import { BookingItemInterface } from "./BookingItemInterface";

export class OfferBanner extends TS_OfferBanner implements BookingItemInterface {}
